import React from "react"
import { createContext } from "use-context-selector"
import { useAppContextState } from "app/@hooks"

const Context = createContext({})

const initialState = {
    monthYear: null, lastDate: null,
    numMonths: 0, isLoading: false,
    allDates: [], indexData: 0, startDate: null,
    endDate: null,
}

export function AppDatesProvider({children}) {
    const { state, replaceState, resetState, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{state, replaceState, resetState, updateState}}>
        {children}
    </Context.Provider>
}
export default Context
